import React from 'react';
import { selectPermissions } from '../../../../../util/store/selectors';
import { useSelector } from '../../../../../util/store/store';
import { OP_STATUS } from "../../../../../util/varibles/constants";
import { ACTION } from '../../../../../util/varibles/permission';
import styles from './style.module.scss';

interface IProps {
    isApprove: boolean
    operation: {
        id?: string
        tenant_id?: string
    }

    handleChangeState(param: any): void
}

const ApproveControl: React.FC<IProps> = (props) => {
    const [permission] = useSelector(selectPermissions([ACTION.OPERATION.UPDATE]))
    if (!props.isApprove || !permission)
        return null;

    const { id, tenant_id } = props.operation;
    const params = {
        operation_id: id,
        tenant_id
    }
    return <div className={styles['container-approve']}>
        <div onClick={() => props.handleChangeState({ ...params, status: OP_STATUS.CANCELED })}>
            Decline
        </div>
        <div onClick={() => props.handleChangeState({ ...params, status: OP_STATUS.APPROVED })}>
            Approve and send to vessel
        </div>
    </div>;
};

export default ApproveControl;

